// extracted by mini-css-extract-plugin
export default {"main":"NodePreview_main__ALqnJ","error":"NodePreview_error__q3EIX","text":"NodePreview_text__4snEy","loading":"NodePreview_loading__SQQx1"};